
import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Form, Input, Select, Checkbox, ColorPicker, DatePicker, NewDatePicker, InfoBlockLabel, Button, MultipleSelect } from '../ui/ot'
import { Badge } from "../ui/badge"
import { FileText, User, Clock, FileCheck, Globe, Monitor, FileType, Star, Users, Target, Calendar } from "lucide-react"


const BaseSelectInfoFormItems = ({
    propsForm,
    field,
    formReloadCount = 0,
    fieldValues = {},
    fieldConfigs = [],
    columnCount = 3, 
    wrapperCol = 24, 
    fill = true, 
    gutter = [16,16], 
    formSubmitCheck = false,
    onFinish = () => {},
    onValuesChange = () => {},
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ?? form_
    const [count, setCount] = useState(0);
    const ComponentMap = {
        MULTISELECT: MultipleSelection,
        SELECT: Select,
        CHECKBOX: Checkbox,
        INPUT: Input,
        COLOR_SELECT: ColorPicker,
        // LABEL: InfoBlockLabel,
        LABEL: InfoBlockLabelText, 
        DATEPICKER: NewDatePicker.DatePickerIncludeMinute, 
        TEXTAREA: Input.Textarea,
    };
    const columnSpan = 24 / (columnCount || 1)
    const [axiosMode, setAxiosMode] = useState("post");


    const onFormValuesChange = (value, { name, type }) => {
        let formValues = null;
        formValues = form.getFieldsValue();
        onValuesChange(formValues)
    };
    const setFieldValue = (name, value) => {
        form.setValue(name, value);
        // 為了拿到最新的值
        const formValues = form.getFieldsValue();
        onValuesChange(formValues);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const onFormFinish = (values) => {
        let formValues = form.getFieldsValue();
        onFinish(formValues)
    };


    useEffect(() => {
        let formValues = null;
        formValues = form.getFieldsValue();
    }, [formReloadCount]);
    useEffect(() => {
        if (fieldValues && Object.keys(fieldValues).length > 0) {
            form.setFieldsValue(fieldValues);
        }
    }, [fieldValues]);
    useEffect(() => {
        if (!!formSubmitCheck) {
            form.validateFields().then(() => {form.submit()})
        }
    }, [formSubmitCheck]);
    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...fieldValues })
        setCount((pre) => pre + 1)
    }, [])


    return (<>
        {/* <Button 
            onClick={() => {
                form.validateFields()
                    .then(() => {form.submit()})
            }}>
            生成
        </Button> */}
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onFormValuesChange}
                    onFinish={onFormFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                                ComponentMap={ComponentMap}
                                fieldConfigs={(fieldConfigs || []).slice().sort((a, b) => {
                                    // hidden = true 的排最後
                                    if (a.hidden && !b.hidden) return 1;
                                    if (!a.hidden && b.hidden) return -1;

                                    // 兩邊都 hidden 相同的時候 → 按 order
                                    const orderA = (a.order === null || a.order === "" || a.order === undefined) ? Infinity : a.order;
                                    const orderB = (b.order === null || b.order === "" || b.order === undefined) ? Infinity : b.order;
                                    return orderA - orderB;
                                }) || []}
                                columnSpan={columnSpan}
                                columnCount={columnCount}
                                wrapperCol={wrapperCol}
                                fill={fill}
                                gutter={gutter}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    </>);
};

const FormItemComponent = ({
    field,
    initialValues = {},
    getAnyFormValue,
    count,
    setFieldValue,
    setCount,
    ComponentMap,
    fieldConfigs = [],
    columnSpan = 4, 
    columnCount = 3, 
    wrapperCol = 24, 
    fill = true, 
    gutter = [16,16],
}) => {

    const widthLength = fieldConfigs.length; // 7
    const groupCount = Math.floor(widthLength / columnCount) + 1; // 7/3=2...1
    const remain = widthLength % columnCount
    const remainFillColumnSpan = Math.floor(24 / remain)

    // 根據 columnCount 分組
    const groupFieldConfigs = () => {
        const groups = [];
        for (let i = 0; i < fieldConfigs.length; i += columnCount) {
            groups.push(fieldConfigs.slice(i, i + columnCount));
        }
        return groups;
    };

    return (
        <>
            <Row gutter={gutter}>
                {fieldConfigs &&
                    fieldConfigs?.map((item, item_index) =>
                        <Col span={fill ? ((widthLength - item_index - 1) < remain ? remainFillColumnSpan : columnSpan) : columnSpan} >
                            {
                                (() => {
                                    const {
                                        name,
                                        label,
                                        label_icon,
                                        label_css,
                                        component,
                                        component_type,
                                        placeholder, 
                                        selection_selection_option_data,
                                        badge,
                                        badge_name, 
                                        label_content, 
                                        order,
                                        disabled,
                                        hidden, 
                                        value, 
                                    } = item;

                                    const fieldName = name;
                                    const Component = ComponentMap[component_type];
                                    const componentPlaceholder = placeholder || "變更內容...";
                                    const formLabel = label || "";
                                    const formLabelIcon = label_icon || "";
                                    // const formLabelIcon = <FileText /> || "";
                                    const formLabelCSS = label_css || "";
                                    const options = selection_selection_option_data || [];
                                    // const componentValue = getAnyFormValue(fieldName);
                                    const componentValue = value;
                                    const badgeShow = badge;
                                    const badgeText = badge_name;
                                    const content = label_content;
                                    const componentHidden = hidden;
                                    const componentDisable = disabled;
                                    if (!Component) return null;
                                    return <Form.Item
                                        labelCol={24}
                                        wrapperCol={wrapperCol}
                                        {...field}
                                        name={[field?.name ?? '', fieldName]}
                                        fieldKey={[field?.fieldKey ?? '', fieldName]}
                                        label={
                                        <>
                                            <Row>
                                            {/* {formLabelIcon} */}
                                            <div dangerouslySetInnerHTML={{ __html: formLabelIcon }} />
                                            {label && <label className={formLabelCSS}>{formLabel}</label>}
                                            </Row>
                                        </>
                                        }
                                        initialValue={initialValues?.name}
                                        labelAlign={"vertical"}
                                        hidden={componentHidden}
                                        disabled={componentDisable}
                                    >
                                        <Component
                                            name={fieldName}
                                            value={componentValue}
                                            placeholder={componentPlaceholder}
                                            allowClear={true}

                                            // 下拉式選單選項
                                            options={options}
                                            selected={[1,2]}

                                            // 純文字 props 
                                            badge={badgeShow}
                                            badgeName={badgeText}
                                            labelContent={content}

                                            // 觸發事件
                                            onSelectChange={(value) => {
                                                setFieldValue(fieldName, value); // ✅ 更新 Form 中的值
                                            }}
                                        />
                                    </Form.Item>;
                                })()
                            }
                        </Col>
                    )}
            </Row>
        </>
    );
};

const InfoBlockLabelText = ({
    badge = false,
    badgeName = "",
    labelContent = "", 
}) => {
    return (
        <div className="flex items-center gap-2">
            {badge  && <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">{badgeName}</Badge>}
            <Row className="text-gray-500">{labelContent}</Row>
        </div>
    )
}
const MultipleSelection = ({
    options = [],
    value = [],
    onSelectChange = () => {},
}) => {
    const [selection, set_selection] = useState(Array.isArray(value) ? value : []);

    useEffect(() => {
        set_selection(Array.isArray(value) ? value : []);
    }, [value]);

    return (
        <MultipleSelect
            options={options}
            selected={Array.isArray(selection) ? selection : []}
            onSelectChange={(newValue) => {
                const nextValue = Array.isArray(newValue) ? newValue : [];
                set_selection(nextValue);
                onSelectChange(nextValue);
            }}
        />
    );
};
export default BaseSelectInfoFormItems;
